export const wordCloud = {
    title: 'Word Cloud',
    wordCloudChartTitle: "Company's WordCloud",
    wordCloudBarTitle: "Company's Word Frequency",
    wordCloudCompanyBarTitle: 'Search for Companies by Word'
}
